export default __webpack_public_path__ + "static/media/Ignition.f7fed631.jpg";